<ng-container *ngIf="vm$ | async as vm">
	<app-matter-url-pdf-viewer
		*ngIf="vm.file?.url"
		[googleSrcUrl]="vm.file?.url"
		[fileName]="vm.file?.name"
		[fileType]="vm.file?.fileType"
		class="h-full"
		[showDelete]="true"
		(delete)="deleteFile()"
	></app-matter-url-pdf-viewer>
</ng-container>
